export enum InputType {
    Undefined,
    SSN,
    CompanyId,
}
